function ListChatModel({
  id,
  message,
  name,
  avatar,
  time,
  unreadCount,
  type
}) {
  let obj = {};
  obj.id = id;
  obj.message = message;
  obj.name = name;
  obj.avatar = avatar;
  obj.time = time;
  obj.unreadCount = unreadCount;
  obj.type = type;
  return obj;
}

export default ListChatModel;
